app.Document = (
    function () {
        var doc = {
            Index: function () {
                $(document).on('click', '[data-button-type="document-add-button"]', function () {
                    var buttonId = $(this).attr('id');
                    var target = $(this).data('component-action-target');

                    $.ajax("/document/VerifyCanUploadDocument")
                        .done(function (results) {
                            // If result is true, there is room for more documents, if false, max documents uploaded
                            if (results == true) {
                                return true;
                            } else {
                                $('[data-component-target="' + target + '"]').find(':first-child').first().remove();
                                toastr.error("Too many documents added.  Please delete one before continuing");
                                return false;
                            }
                        })
                        .fail(function () { toastr.error("Unable to add document"); });
                });
                $(document).on('component-save-complete-Document', function () {
                    window.location.reload();
                });
                //hide the text box instructions that are specific to the application but exist in the shared view here
                $(".document-instruction").hide();
            },
            Application: function () {
                $("*[data-document-selected = 'true' i]").each(function () {
                    $(this).closest(".component-view").addClass("border border-primary");
                });

                $(document).on('click', '[data-button-type="document-add-button"]', function () {
                    var buttonId = $(this).attr('id');
                    var target = $(this).data('component-action-target');

                    $.ajax("/document/VerifyCanUploadDocument")
                        .done(function (results) {
                            // If result is true, there is room for more documents, if false, max documents uploaded
                            if (results == true) {
                                return true;
                            } else {
                                $('[data-component-target="' + target + '"]').find(':first-child').first().remove();
                                toastr.error("Too many documents added.  Please delete one before continuing");
                                return false;
                            }
                        })
                        .fail(function () { toastr.error("Unable to add document"); });
                });

                // variable to help prevent multiple clicks on select document
                var active = true;
                $(document).on('click', '[data-role="select-document"]', function () {

                    // if active is false, we are currently running the function, so return
                    if (!active) {
                        return;
                    }

                    active = false;

                    //update database
                    var target = $(this).data('target');
                    var buttonId = $(this).attr('id');
                    var that = $(this);

                    var currentHtml = that.html();
                    that.html('<div class="text-center"><img src="/Content/Images/Icons/loading.gif" /></div>');

                    var applicationId = app.page.id;
                    $.post("/document/SelectApplicationDocument", { id: $(this).data('document-id'), applicationId: applicationId })
                        .done(function (results) {
                            if (results.ValidRequest) {
                                if (results.Selected) {
                                    $("#" + target).closest(".component-view").addClass("border border-primary");
                                    $("#" + buttonId).html('<i class="fa fa-check-square-o fa-2x" aria-hidden="true"></i>');
                                    $("#" + buttonId).attr("aria-label", "Checkbox to remove document from application");
                                    // notify user and trigger event
                                    toastr.success("Document selected");
                                    $(document).trigger("document-selected", this);
                                } else {
                                    $("#" + target).closest(".component-view").removeClass("border border-primary");
                                    $("#" + buttonId).html('<i class="fa fa-square-o fa-2x" aria-hidden="true"></i>');
                                    $("#" + buttonId).attr("aria-label", "Checkbox to select document for application");

                                    // notify user and trigger event
                                    toastr.success("Document unselected");
                                    $(document).trigger("document-selected", this);
                                }
                            } else {
                                that.html(currentHtml);
                                toastr.error("Unable to select this document.  Please reload the page and try again or contact support.");
                            }
                            active = true;
                        })
                        .fail(function () {
                            that.html(currentHtml);
                            toastr.error("Unable to select this document.  Please contact support.");
                            active = true;
                        });
                });
            }
        }
        return doc;
    }()
);